import ApplicationAdapter from './application';

/**
 * Adapter for the Approvable (TasApprovable) model.
 *
 * Provides state-transition actions against the /tas-approvables endpoint.
 * The backend uses `state_transitionable` concern, so transitions are:
 *   PATCH /tas-approvables/:id/transition/state/:event_name  => 204 No Content
 */
class TasApprovableAdapter extends ApplicationAdapter {
  /**
   * Trigger the abandon event on a TasApprovable.
   * Used when an employee removes a receipt — the associated approvable is abandoned.
   */
  async abandon(approvableId: string) {
    // @ts-expect-error stop using adapters
    const url = this.buildURL('tas-approvable', approvableId) + '/transition/state/abandon';
    await this.ajax(url, 'PATCH');
  }
}

export default TasApprovableAdapter;
